import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { IDivision } from '@user/store/divisions/typings'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'

type Props = {
  divisions: IDivision[]
  name: string
  label: string
  show: boolean
  required?: boolean
  disabled?: boolean
  density?: DensityType
}

export default function DivisionSelect(props: Props) {
  const { name, show, disabled, required, divisions, ...rest } = props

  const { initialOption, isSubmitting, helperText, showError, ...restUseData } =
    useData({ required, name, divisions })

  const { handelChange, handelFocus, handelBlur } = useHandlers({ name })

  return show ? (
    <Box>
      <Select<IDivision>
        {...restUseData}
        {...rest}
        disabled={isSubmitting || disabled}
        required={required}
        error={showError}
        onChange={handelChange}
        value={initialOption}
        optionMode={'normal'}
        onFocus={handelFocus}
        onBlur={handelBlur}
        testId={name}
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  ) : null
}
